"use client";

import {
  CSSProperties,
  FormHTMLAttributes,
  JSX,
  ReactNode,
  useEffect,
  useRef,
} from "react";
import {
  GlobalIndexState,
  useGlobalContext,
} from "@/src/context/GlobalContext";
import {
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Modal as Modals,
} from "@heroui/react";
import React from "react";

export default function Modal({
  children,
  customZIndex,
  customwidth,
  customheight,
  minheight,
  minwidth,
  closestate,
  bgblur,
  action,
}: {
  children: ReactNode;
  customZIndex?: number;
  customwidth?: string;
  customheight?: string;
  minwidth?: string;
  minheight?: string;
  bgblur?: boolean;
  action?: () => void;
  closestate:
    | "createProduct"
    | "createBanner"
    | "createCategory"
    | "createPromotion"
    | "createUser"
    | "addsubcategory"
    | "updatestock"
    | "confirmmodal"
    | "filteroption"
    | "discount"
    | "editprofile"
    | "editsize"
    | "none"
    | string;
}) {
  const ref = useRef<HTMLDivElement | null>(null);
  const { setopenmodal, setglobalindex, globalindex, setalldata } =
    useGlobalContext();

  useEffect(() => {
    document.body.style.overflowY = "hidden";
    return () => {
      document.body.style.overflowY = "auto";
    };
  }, []);

  return (
    <div
      onClick={(e) => {
        if (
          ref.current &&
          !ref.current.contains(e.target as Node) &&
          closestate !== "none"
        ) {
          const updateIndex = Object.fromEntries(
            Object.entries(globalindex).map(([key, _]) => [key, -1]),
          ) as unknown as GlobalIndexState;
          action && action();
          setglobalindex(updateIndex);

          if (closestate === "createCategory") {
            setalldata((prev) => ({ ...prev, category: [] }));
          }
          setopenmodal((prev) => ({ ...prev, [closestate]: false }));
        }
      }}
      style={{ zIndex: customZIndex, overflow: "hidden" }}
      className={`modal__container z-50 fixed flex flex-col items-center justify-center left-0 top-0 w-full h-screen ${
        bgblur ? "backdrop-blur-md" : ""
      } `}
    >
      <div
        ref={ref}
        style={{
          width: customwidth,
          height: customheight,
          minHeight: minheight,
          minWidth: minwidth,
        }}
        className="w-1/2 h-1/2 max-small_phone:h-screen flex flex-col justify-center items-center"
      >
        {children}
      </div>
    </div>
  );
}

interface SecondaryModalInterface {
  header?: () => ReactNode;
  children: ReactNode;
  footer?: (onClose: () => void) => ReactNode;
  open: boolean;
  onPageChange?: (val: boolean) => void;
  closebtn?: boolean;
  style?: CSSProperties;
  scroll?: "normal" | "inside" | "outside";
  isForm?: FormHTMLAttributes<HTMLFormElement>;
  placement?:
    | "center"
    | "auto"
    | "top"
    | "top-center"
    | "bottom"
    | "bottom-center";
  size:
    | "xs"
    | "sm"
    | "md"
    | "lg"
    | "xl"
    | "2xl"
    | "3xl"
    | "4xl"
    | "5xl"
    | "full";
}
export function SecondaryModal({
  header,
  children,
  footer,
  open,
  size,
  onPageChange,
  closebtn,
  style,
  scroll,
  placement,
  isForm,
}: SecondaryModalInterface) {
  return (
    <Modals
      hideCloseButton={closebtn ? !closebtn : true}
      size={size}
      isOpen={open}
      placement={placement}
      closeButton
      style={style}
      className="z-200 aria-hidden:false"
      scrollBehavior={scroll}
      onOpenChange={(open) => {
        onPageChange && onPageChange(open);
      }}
    >
      <ModalContent>
        {(onClose) => (
          <>
            {header && (
              <ModalHeader className="flex flex-col gap-1">
                {header()}
              </ModalHeader>
            )}
            {isForm ? (
              <form {...isForm}>
                <ModalBody className="overflow-y-auto">{children}</ModalBody>
                {footer && <ModalFooter>{footer(onClose)}</ModalFooter>}
              </form>
            ) : (
              <>
                <ModalBody className="overflow-y-auto">{children}</ModalBody>
                {footer && <ModalFooter>{footer(onClose)}</ModalFooter>}
              </>
            )}
          </>
        )}
      </ModalContent>
    </Modals>
  );
}
